<form [formGroup]="addressSearchForm">
  <img
    src="./assets/images/icons/Icon_Search2.svg"
    alt="Customer search icon"
    class="search-img"
  />

  @if (containInputValue('control')) {
  <img
    src="./assets/images/icons/Icon_Close.svg"
    alt="Customer close icon"
    class="close-img"
    (click)="clearAddressInput()"
  />
  } @else {
  <img
    src="./assets/images/icons/Icon_Target.svg"
    alt="Customer position button"
    class="input-img"
    (click)="getUserLocation()"
  />
  }

  <input
    id="search-dealer"
    type="text"
    placeholder="{{ 'dealer.select-dealer-input' | translate }}"
    formControlName="control"
  />

  <div class="suggestions">
    @if (showFinder()) { @for (suggest of suggestions(); track
    suggest.placePrediction.placeId; let i = $index) {
    <button
      (click)="getSuggest(suggest.placePrediction)"
      (mousedown)="$event.preventDefault()"
      [id]="'result-' + i"
      type="button"
    >
      {{ suggest.placePrediction.text.text }}
    </button>
    } }
  </div>
</form>
